
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MyCourse from '../components/MyCourse.vue'
import MyStudy from '../components/MyStudy.vue'
import MyAccount from '../components/MyAccount.vue'
import MyCalendar from '../components/MyCalendar.vue'
import Experience from '../components/Experience.vue'
import Book from '../components/Book.vue'
import HeaderUserPanel from '../components/HeaderUserPanel.vue'
import StudyRecord, { type StudyRecordType } from '../components/StudyRecord.vue'

@Observer
@Component({
  components: {
    MyCourse,
    MyStudy,
    MyAccount,
    MyCalendar,
    Experience,
    StudyRecord,
    Book,
    HeaderUserPanel
  }
})
export default class MyClassroom extends Vue {
  userPanelData: {
    follow: number
    followed: number
    like: number
  } = {
    follow: 8,
    followed: 21,
    like: 110
  }

  experienceData: {
    count: number
    level: number
    progress: number
    sumexperience: number
  } = { count: 0, level: 0, progress: 0, sumexperience: 0 }

  studyRecordData: StudyRecordType = {
    learnTime: 0,
    weekLearnTime: 0,
    learnStartTime: 0,
    learnEndTime: 0,
    lastWeekLearnData: []
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  init(): void {
    this.studyRecordData = {
      learnTime: 321.4,
      weekLearnTime: 30,
      learnStartTime: 1764559349000,
      learnEndTime: 1766373749000,
      lastWeekLearnData: [
        { time: 0, date: 1766632949000 },
        { time: 10, date: 1766719349000 },
        { time: 20, date: 1766805749000 },
        { time: 35, date: 1766892149000 },
        { time: 32, date: 1766978549000 },
        { time: 26, date: 1767064949000 },
        { time: 10, date: 1767237749000 }
      ]
    }
    this.experienceData = {
      count: this.UserStore.count,
      progress: this.UserStore.progress,
      sumexperience: this.UserStore.sumexperience[this.UserStore.level + 1],
      level: this.UserStore.level
    }
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
